
import React, {useState} from 'react';
import Header from '../menu/menu';
import classNames from 'classnames';
import {  Spin } from 'antd';
import { useSelector} from 'react-redux';
import { LoadingGif } from 'components';
import { MetaTags } from 'react-meta-tags';

const Layout = ({
  children,
  customMenuRender,
  withoutHeaderDropdown,
  hamburgerMenuData,
  hamburgerMenuClass,
  hamburgerMenuWithButton,
  withoutCreditInfo,
  menuSinglePageV2,
  whiteLogo
}) => {
  const [isHidden, setIsHidden] = useState(false);
  const {loading, setLoading} = useSelector(state=>state.loader);
  var body = document.getElementsByTagName("BODY")[0];

  { isHidden == true ? body.classList.add("hidden") : body.classList.remove("hidden") }

  return (
    <div>
       <MetaTags> 
    <title>Toplu SMS Gönderme - Çoklu ZİM Gönderme Programı | Mesaj Üssü</title>
            <meta name="description" content="Toplu SMS gönderme paneli Turkcell Mesaj Üssü'ne ücretsiz üye olun, Zengin İçerikli Mesaj ve toplu SMS'lerinizi paylaşmaya başlayın!" />
          </MetaTags>
      <Header
        withoutCreditInfo={withoutCreditInfo}
        hamburgerMenuWithButton={hamburgerMenuWithButton}
        hamburgerMenuData={hamburgerMenuData}
        hamburgerMenuClass={hamburgerMenuClass}
        withoutDropdown={withoutHeaderDropdown}
        customMenuRender={customMenuRender}
        menuSinglePageV2={menuSinglePageV2}
        setIsHidden={setIsHidden}
        isHidden={isHidden}
        whiteLogo={whiteLogo}
      />
      {/* {loading ? <LoadingGif /> : null} */}
     <Spin  spinning={loading}    indicator={<LoadingGif></LoadingGif>}  >{children}</Spin> 
    </div>  
  );
};

export default Layout;
